import { WorkflowStepType } from '@kindo/universal';

export const WORKFLOW_STEP_TYPE_BADGE_LABELS: Record<WorkflowStepType, string> =
  {
    [WorkflowStepType.LLM]: 'LLM',
    [WorkflowStepType.INTEGRATION_ACTION]: 'Action',
    [WorkflowStepType.API_ACTION]: 'API'
  };

export const WORKFLOW_TRIGGER_ENTERPRISE_TOOLTIP =
  'Automated agents are only available for Enterprise plans';
